import { zUid } from "src/types/zUid";
import z from "zod";

export const zSample2Row = z.object({
  id: zUid,
  point: z.string(),
  fromDictionary: z.boolean().nullish(),
  dictionaryPointId: zUid.nullish(),
  description: z.string().nullish(), // LPLM-5038
  criticality: z.boolean(),
  tolMinus: z.number(),
  tolPlus: z.number(),
  requestedValue: z.number(),
  differenceValue: z.number().nullish(),
  actualValue: z.number().nullish(),
  newValue: z.number().nullish(),
  position: z.number(),
});
export type ZSample2Row = z.infer<typeof zSample2Row>;

export const zSample2 = z.object({
  sizeName: z.string(),
  mcName: z.string(),
  imageIds: z.string().array().nullish(),
  header: z.string().array(),
  permissions: z.string().array(),
  rows: zSample2Row.array(),
});
export type ZSample2 = z.infer<typeof zSample2>;
